<template>
  <div class="custom">

    <!-- Hero -->
    <section class="hero-section">
      <div class="hero-inner">
        <h1 class="hero-title">项目定制</h1>
        <p class="hero-desc">高超技术经验让您的项目顺利交付</p>
        <div class="tag-list">
          <div class="tag" v-for="tag in tags" :key="tag.label">
            <svg class="tag-icon" fill="currentColor" viewBox="0 0 20 20">
              <path :fill-rule="tag.fillRule||''" :clip-rule="tag.clipRule||''" :d="tag.icon"/>
            </svg>
            <span>{{ tag.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 为什么选择我们 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <div class="section-header">
          <h2>为什么选择我们？</h2>
          <p>Why Choose Us？</p>
        </div>
        <div class="why-grid">
          <!-- 左侧列表 -->
          <div class="why-list">
            <div class="why-item" v-for="item in whyItems" :key="item.title">
              <div class="why-icon" :style="{ background: item.iconBg }">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" :style="{ color: item.iconColor }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon"/>
                </svg>
              </div>
              <div>
                <h3 class="why-title">{{ item.title }}</h3>
                <p class="why-desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <!-- 右侧插图 -->
          <div class="why-visual">
            <div class="qrcode-wrap" @click="copyWechat" title="点击复制微信号">
              <img src="@/assets/qrcode.png" alt="联系二维码" class="qrcode-img" />
              <div class="qrcode-tip">点击复制微信号</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术选型矩阵 -->
    <section class="section bg-dot">
      <div class="section-inner">
        <div class="section-header">
          <h2>技术选型矩阵</h2>
          <p>灵活选择技术方案，满足不同项目需求</p>
        </div>
        <div class="tech-grid">
          <div class="tech-card" v-for="item in techMatrix" :key="item.title">
            <h3 class="tech-title" :style="{ color: item.color }">{{ item.title }}</h3>
            <div class="tech-row">
              <span class="tech-label">前端</span>
              <span class="tech-val">{{ item.frontend }}</span>
            </div>
            <div class="tech-row">
              <span class="tech-label">后端</span>
              <span class="tech-val">{{ item.backend }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 定制流程 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <div class="section-header">
          <h2>定制流程</h2>
          <p>每项化服务体系，确保每一环节精益求精</p>
        </div>
        <div class="flow-wrap">
          <div class="flow-line"></div>
          <div class="flow-grid">
            <div class="flow-step" v-for="step in flowSteps" :key="step.title">
              <div class="flow-icon" :style="{ background: step.iconBg }">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" :style="{ color: step.iconColor }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="step.icon"/>
                </svg>
              </div>
              <h3 class="flow-title">{{ step.title }}</h3>
              <p class="flow-desc">{{ step.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'Custom',
  data() {
    return {
      tags: [
        { label: '个性化定制', fillRule: 'evenodd', clipRule: 'evenodd', icon: 'M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z' },
        { label: '选题推荐', icon: 'M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z' },
        { label: '项目答辩', fillRule: 'evenodd', clipRule: 'evenodd', icon: 'M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z' },
        { label: '代码讲解', fillRule: 'evenodd', clipRule: 'evenodd', icon: 'M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z' },
      ],
      whyItems: [
        { title: '需求精准理解', desc: '深度沟通，确保功能贴合业务场景', iconBg: '#dbeafe', iconColor: '#2563eb', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
        { title: '高效交付周期', desc: '敏捷开发，快速迭代，按时交付', iconBg: '#dcfce7', iconColor: '#16a34a', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
        { title: '代码安全可靠', desc: '规范编码，保障系统稳定运行', iconBg: '#f3e8ff', iconColor: '#9333ea', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
        { title: '全程透明沟通', desc: '定期汇报进度，随时反馈调整', iconBg: '#ffedd5', iconColor: '#ea580c', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
        { title: '合理透明报价', desc: '无隐藏费用，按需计价', iconBg: '#e0e7ff', iconColor: '#4f46e5', icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
        { title: '售后保障支持', desc: '交付后持续跟进，答辩无忧', iconBg: '#fce7f3', iconColor: '#db2777', icon: 'M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z' },
      ],
      techMatrix: [
        { title: 'Java 项目', color: '#4f46e5', frontend: 'JSP / Vue / Element / Thymeleaf', backend: 'JSP / SSM / SpringBoot / SpringCloud' },
        { title: 'Python 项目', color: '#9333ea', frontend: 'HTML / Vue / ElementUI', backend: 'Django / Flask / Spider' },
        { title: '小程序项目', color: '#2563eb', frontend: 'Native / Uniapp', backend: 'SSM / SpringBoot / Python' },
        { title: 'Node.js 项目', color: '#16a34a', frontend: 'Vue / Vant / ElementUI', backend: 'Express / Koa / Nest.js' },
      ],
      flowSteps: [
        { title: '需求沟通', desc: '详细了解您的项目需求', iconBg: '#e0e7ff', iconColor: '#4f46e5', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
        { title: '方案制定', desc: '制定合适的技术方案', iconBg: '#f3e8ff', iconColor: '#9333ea', icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' },
        { title: '开发实现', desc: '高可读性代码，完整注释', iconBg: '#dbeafe', iconColor: '#2563eb', icon: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4' },
        { title: '交付服务', desc: '代码注释或讲解支持', iconBg: '#dcfce7', iconColor: '#16a34a', icon: 'M5 13l4 4L19 7' },
      ]
    }
  },
  created() {
    this.increasePageView()
  },
  methods: {
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'custom' }
      }).catch(() => {})
    },
    copyWechat() {
      navigator.clipboard.writeText('Gk_Coding').then(() => {
        this.$message({ message: '微信号已复制：Gk_Coding', type: 'success', duration: 2000 })
      }).catch(() => {
        this.$message({ message: '复制失败，请手动输入：Gk_Coding', type: 'warning', duration: 2000 })
      })
    }
  }
}
</script>

<style scoped>
.custom { background: #fff; }

/* ===== Hero ===== */
.hero-section {
  background: #fff;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
    linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.hero-inner {
  max-width: 896px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.hero-title {
  font-size: 28px;
  font-weight: 900;
  color: #4f46e5;
  margin: 0 0 16px;
}

@media (min-width: 768px) { .hero-title { font-size: 48px; margin: 0 0 32px; } }

.hero-desc {
  font-size: 15px;
  color: #4b5563;
  line-height: 1.75;
  margin: 0 0 24px;
}

@media (min-width: 768px) { .hero-desc { font-size: 18px; margin: 0 0 48px; } }

.tag-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

@media (min-width: 768px) { .tag-list { gap: 24px; } }

.tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 9999px;
  padding: 6px 12px;
}

@media (min-width: 768px) { .tag { padding: 8px 16px; gap: 8px; } }

.tag-icon {
  width: 16px;
  height: 16px;
  color: #6366f1;
  flex-shrink: 0;
}

@media (min-width: 768px) { .tag-icon { width: 20px; height: 20px; } }

.tag span {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

@media (min-width: 768px) { .tag span { font-size: 14px; } }

/* ===== 通用 ===== */
.section { padding: 40px 0; }
.bg-gray { background: #f9fafb; }
.bg-dot {
  background: #fff;
  background-image: radial-gradient(circle, #d1d5db 1px, transparent 1px);
  background-size: 30px 30px;
}

.section-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (min-width: 768px) { .section-inner { padding: 0 32px; } }

.section-header {
  text-align: center;
  margin-bottom: 32px;
}

@media (min-width: 768px) { .section-header { margin-bottom: 48px; } }

.section-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

@media (min-width: 768px) { .section-header h2 { font-size: 36px; margin: 0 0 12px; } }

.section-header p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* ===== 为什么选择我们 ===== */
.why-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: center;
}

@media (min-width: 1024px) {
  .why-grid { grid-template-columns: 2fr 1fr; gap: 32px; }
}

.why-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;
}

@media (min-width: 768px) { .why-list { grid-template-columns: 1fr 1fr; gap: 16px 32px; } }

.why-item {
  display: flex;
  gap: 12px;
  align-items: center;
  background: #fff;
  border: 1px solid #f3f4f6;
  padding: 12px;
}

@media (min-width: 768px) {
  .why-item {
    background: none;
    border: none;
    border-radius: 0;
    padding: 0;
    align-items: flex-start;
  }
}

.why-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.why-icon svg { width: 22px; height: 22px; }

.why-title {
  font-size: 17px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px;
}

@media (min-width: 1024px) {
  .why-title { font-size: 19px; white-space: nowrap; }
}

.why-desc {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
}

@media (min-width: 1024px) {
  .why-desc { font-size: 14px; white-space: nowrap; }
}

.why-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

@media (min-width: 1024px) {
  .why-visual { justify-content: flex-end; min-height: 400px; align-self: stretch; }
}

.qrcode-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
}

@media (min-width: 768px) { .qrcode-img { width: 240px; height: 240px; } }

.qrcode-wrap {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.qrcode-tip {
  position: absolute;
  bottom: -32px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.7);
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}

.qrcode-wrap:hover .qrcode-tip {
  opacity: 1;
}

/* ===== 技术选型矩阵 ===== */
.tech-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  max-width: 896px;
  margin: 0 auto;
}

@media (min-width: 768px) { .tech-grid { grid-template-columns: 1fr 1fr; } }

.tech-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 24px;
  transition: border-color 0.2s;
}

.tech-card:hover { border-color: #3b82f6; }

.tech-title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 16px;
}

.tech-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.tech-row:last-child { margin-bottom: 0; }

.tech-label {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 600;
  flex-shrink: 0;
}

.tech-val {
  font-size: 14px;
  color: #374151;
}

/* ===== 定制流程 ===== */
.flow-wrap { position: relative; }

.flow-line {
  display: none;
  position: absolute;
  top: 32px;
  left: 0; right: 0;
  height: 1px;
  background: #d1d5db;
}

@media (min-width: 1024px) { .flow-line { display: block; } }

.flow-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px 16px;
}

@media (min-width: 1024px) { .flow-grid { grid-template-columns: repeat(4, 1fr); } }

.flow-step { text-align: center; position: relative; }

.flow-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  position: relative;
  z-index: 1;
}

.flow-icon svg { width: 28px; height: 28px; }

.flow-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 12px;
}

.flow-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.625;
  margin: 0;
}
</style>
